<template>
  <div v-if="total">
    <hr />
    <nav aria-label="Pagination" class="paging">
      <ul class="menu align-center">

        <li class="paging-previous">
          <a 
            :class="{ disabled: prev == false }" 
            @click.prevent="toPage(prev)">
            Previous
          </a>
        </li>

        <template v-for="page in pages">
          <li :class="{ 'is-active': isCurrent(page) }" :key="page">
            <span v-if="isNaN(page)">
              {{ page }}
            </span>
            <a v-else @click.prevent="toPage(page)" class="page-number">{{ page }}</a>
          </li>
        </template>
        

        <li class="paging-next">
          <a 
            :class="{ disabled: next == false }"
            @click.prevent="toPage(next)">
            Next
          </a>
        </li>

      </ul>
    </nav>
  </div>
</template>

<script>
var VueScrollTo = require('vue-scrollto');

export default { 
  name: 'Pagination',
  props: {
    params: {
      type: Object,
      required: true
    },
    total: {
      type: Number
    }
  },
  methods: {
    isCurrent(page) {
      return page == this.params.page
    },
    toPage(page) {
      this.$emit('to-page', page)
      let el = this.$root.$el
      VueScrollTo.scrollTo(el, 100, {offset: -20})
    },
    getRange (start, end) {
      return Array(end - start + 1)
        .fill()
        .map((v, i) => i + start)
    }
  },
  computed: {
    prev () {
      let curr_page = this.params.page
      if (curr_page > 1) {
        let prev = curr_page - 1
        return prev
      } else {
        return false
      }
    },
    next () {
      let page_count = this.total
      let curr_page = this.params.page
      if (curr_page && curr_page < page_count) {
        let next = curr_page + 1
        return next 
      } else {
        return false
      }
    },
    pages () {
      let delta
      if (this.total <= 7) {
        // delta === 7: [1 2 3 4 5 6 7]
        delta = 7
      } else {
        // delta === 2: [1 ... 4 5 6 ... 10]
        // delta === 4: [1 2 3 4 5 ... 10]
        delta = this.params.page > 4 && this.params.page < this.total - 3 ? 2 : 4
      }

      const range = {
        start: Math.round(this.params.page - delta / 2),
        end: Math.round(this.params.page + delta / 2)
      }

      if (range.start - 1 === 1 || range.end + 1 === this.total) {
        range.start += 1
        range.end += 1
      }

      let pages =
        this.params.page > delta
          ? this.getRange(Math.min(range.start, this.total - delta), Math.min(range.end, this.total))
          : this.getRange(1, Math.min(this.total, delta + 1))

      const withDots = (value, pair) => (pages.length + 1 !== this.total ? pair : [value])

      if (pages[0] !== 1) {
        pages = withDots(1, [1, '...']).concat(pages)
      }

      if (pages[pages.length - 1] < this.total) {
        pages = pages.concat(withDots(this.total, ['...', this.total]))
      }

      return pages
    }
  }
}
</script>
